<template>
  <transition
    name="transition-block"
    mode="out-in"
    @after-enter="afterTransition"
    @after-leave="afterTransition"
  >
    <slot />
  </transition>
</template>

<script>
  export default {
    name: 'ZgTransitionBlock',
    methods: {
      afterTransition () {
        this.$emit('after-transition')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .transition-block-enter-active,
  .transition-block-leave-active {
    transition: all 0.3s ease-in-out;
    overflow: hidden;
  }

  .transition-block-enter,
  .transition-block-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .transition-block-enter-to,
  .transition-block-leave {
    max-height: rem(5000px);
    opacity: 1;
  }
</style>
